import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrxServicesMethodPage } from './trxservices-method.page';

const routes: Routes = [
  {
    path: '',
    component: TrxServicesMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrxServicesMethodPageRoutingModule {}
